// @flow

import { selectCartCurrency, selectCountTotalProducts } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import styles from './TotalArticles.scss';

type Props = { beforeTaxes: number };

export function TotalArticles({ beforeTaxes }: Props): React.MixedElement {
  const { __, formatPrice } = useTranslator();

  const totalProducts = useAppSelector(selectCountTotalProducts);
  const currency = useAppSelector(selectCartCurrency);

  return (
    <div className={styles.container}>
      <p>
        {__('%(count)s articles', {
          count: totalProducts,
        })}
      </p>
      <p>{formatPrice(beforeTaxes, currency)}</p>
    </div>
  );
}
